<template>
    <div style="position: relative">
        <div class="incident-date" :class="dateColor" :style="'height:' + height + 'px'" v-if="showDate">
            {{ dateAsString (this.date) }}
        </div>

        <c-list-card
            :height      = "height"
            :edit        = "false"
            border-width = "pa-2"
            @selected    = "onClick(false)"
            @context     = "onContext"
            @site        = "onSite"
        >
            <template v-slot:title>
                <div class="card-title title-line v-flex">
                    <div class="mr-1">
                        <c-tag :label="contract(item)" :active="item.liftmanagement && item.liftmanagement !== 0" background-color="primary"  />
                    </div>
                    <div>
                        <slot name = "hint"></slot>
                    </div>
                    <div>
                        {{ item.incidentId }} {{ item.typeName }}
                    </div>
                    <div>
                        <slot name = "date" />
                    </div>
                </div>
                <v-spacer />
                <div class="text-right customer-name">
                    {{ item.customerName }}
                </div>
                <slot name="tag" />
                <div style="margin-top: -2px;" :style="showDate ? 'margin-right: 12px;' : ''">
                    <c-site-icon
                        v-if      = "site"
                        :site     = "site"
                        @selected = "onSite"
                    />
                </div>
            </template>
            <template v-slot:body>
                <div class="card-subtitle v-flex">
                    <div class="address-line">
                        {{ item.street }}, {{ item.zip }} {{ item.city }}

                    </div>
                    <v-spacer />
                    <div class="primary--text" style="font-size: 13px; " :style="showDate ? 'margin-right: 14px;' : ''">{{ item.elevatorNo}}</div>
                </div>

                <slot name="comment" />
            </template>
        </c-list-card>

        <v-menu
            v-model="showMenu"
            :position-x="x"
            :position-y="y"
            absolute
            offset-y
        >
            <v-list>
                <v-list-item @click = "onClick(false)">
                    <v-list-item-title>Gehe zum Ereignis</v-list-item-title>
                </v-list-item>
                <v-list-item @click = "onClick(true)">
                    <v-list-item-title>Gehe zum Ereignis in neuen Fenster</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>

import Core      from "@/modules/core/service/Core";
import CListCard from "@/modules/core/components/utils/CListCard.vue";
import CSiteIcon from "@/modules/msd/unit/components/controlls/CSiteIcon.vue";
import Inc from "@/modules/inc/service/Inc";
import CTag from "@/modules/core/components/utils/CTag.vue";

export default {
    name: "PIncTodoCard",

    components: {
        CTag,
        CSiteIcon,
        CListCard
    },

    props: {
        item: {

        },

        date: {
            required: false,
            type: String,
            default: function () {
                return null;
            }
        },

        showDate: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        dateColor: {

        },

        clickEvent: {

        },

        enableMenu: {
            required: false,
            type: Boolean,
            default: function () {
                return true;
            }
        },

        height: {
            required: false,
            type: Number,
            default: function () {
                return 80;
            }
        }
    },

    data: () => ({
        site:null,
        x: null,
        y: null,
        showMenu: false,
    }),

    mounted() {
        this.setSite();
    },

    watch: {
        item () {
            this.setSite();
        }
    },

    methods: {
        onClick (newWindow) {
            if (this.clickEvent) {
                this.clickEvent (newWindow);
                return;
            }

            if (newWindow) {
                let route = this.$router.resolve({name: 'incident', params: { id: this.item.incidentId, unitId: this.item.unitId }});
                window.open(route.href, '_blank');
                return;
            }

            Inc.goto(this, this.item.incidentId, this.item.unitId);
        },

        onSite () {
            this.$emit("site", this.item)
        },

        onContext (event) {
            event.preventDefault()
            this.showMenu = false
            this.x = event.clientX
            this.y = event.clientY
            this.$nextTick(() => {
                this.showMenu = true
            })
        },

        format (value) {
            return Core.format.datetime.display(value)
        },

        dateAsString (value) {
            if (!value) {
                return "";
            }
            return Core.format.date.display(value)
        },

        contract (item) {
            switch (item.liftmanagement ) {
                case 1: return "LIM";
                case 2: return "DLS";
            }

            return null;
        },

        setSite () {
            if (!this.item) {
                return;
            }

            this.site = {
                id: this.item.unitId,
                status: {
                    id: 1
                },
                type: {
                    symbol: this.item.elevatorSymbol,
                    name  : this.item.elevatorTypeName
                }
            }
        }
    },
}
</script>

<style scoped>

.card-subtitle {
    font-size: 13px;
}

.status-line {
    max-width: calc(100% - 65px);
}

.address-line {
    max-width: calc(100% - 135px);
}

.title-line {
    max-width: calc(100% - 65px);
}

.customer-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 150px;
    max-width: 150px;
}

.status-line, .address-line, .title-line {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.incident-date {
    position: absolute;
    right: 0;
    top: 0;
    writing-mode: vertical-lr;
    font-size: 12px;
    width: 20px;
    text-align: center;
    z-index: 1;
    border-radius: 0 4px 4px 0!important;
    border-left-style: solid;
    border-left-width: 1px;
    border-color: lightgrey!important;
}

</style>